import { collection, onSnapshot } from "firebase/firestore";
import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import { MdDone } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { db } from "../Components/Firebase/Firebase";


const UsersTable = ({ item }) => {
  const navigate = useNavigate();

  const [userdetails, setUserdetails] = useState();

  useEffect(() => {
    const q = collection(db, "usersLesson", item?.id, "MemberShip");

    const unsub = onSnapshot(q, (querySnapshot) => {
      let Blog = [];
      querySnapshot.forEach((doc) => {
        Blog.push({
          id: doc.id,
          ...doc.data(),
        });
        setUserdetails(Blog);
      });
    });

    return () => unsub();
  }, [userdetails]);


  return (
    <tbody>
      <tr key={item.id}>
        <th scope="row">
          <div className="user-profile-n">
            <span>
              <FaUserCircle size={30} />
            </span>
            {item.name}
          </div>
        </th>
        <td data-title="Email">{item.email}</td>
        
        {userdetails?.map((item) => (
          <>
          {item.unlock === true ? (
                 <td data-title="Payment Type">
        OTP
              </td>
              ) : (
                <td data-title="Payment Type">
          EMI
            </td>
                )}
            </>
          ))}
        <td data-title="Payment Type">
          {userdetails?.map((item) => (
            <h1 style={{ fontSize: " 17px", fontWeight: "100" }}>
              {item.Subscription}
            </h1>
          ))}
          {/* <UserComponent1 id={item.id} /> */}
        </td>

        <td
          className="pay-status"
          data-title="Payment Status"
          data-type="currency"
        >
          {userdetails?.map((item) => (
            <>
              {item.Active === true ? (
                <MdDone size={30} />
              ) : (
                <RxCross1 size={30} />
              )}
            </>
          ))}
        </td>
        <td data-title="Enroll Date">
          {item?.createdAt
            ? moment(item.createdAt.toDate()).format("MMMM Do YYYY")
            : null}
        </td>
      
      </tr>
    </tbody>
  );
};

export default UsersTable;
